import { Table, DataRow, ColumnsInterface } from '../types/components/data-rendering'
import { defineStore } from 'pinia'
import { computed, ComputedRef, ref, watch } from 'vue'
import { OrdersModel } from '../models/OrdersModel'

export type Order = {
  artwork_id: number
  quantity: number
  reason: { name: string; label: string }
  comment: string | null
  date: Date
}
export type Orders = Order[]
export type UseOrdersReturn = {
  setOrders: (data: Order[]) => void
  addOrder: (order: Order) => void
  getAllOrders: ComputedRef<Orders>
  getOrdersAsTable: ComputedRef<Table>
  resetStoreState: () => void
}
const orders = ref<Orders>([])
export const useOrders = defineStore('orders', (): UseOrdersReturn => {
  const { writeOrders } = OrdersModel()
  watch(
    orders,
    async (newData) => {
      await writeOrders(newData).catch((error) => console.log(error))
    },
    { deep: true }
  )
  const setOrders = (data: Order[]) => (orders.value = data)
  const addOrder = (order: Order) => orders.value.push(order)
  const getAllOrders = computed(() => orders.value)
  const getOrdersAsTable = computed((): Table => {
    const newData = [...orders.value].map((order) => {
      const { reason, ...rest } = order
      return { reason: reason.label, ...rest }
    })
    const columns: ColumnsInterface = {
      artwork_id: {
        label: {
          en_US: 'Artwork ID',
          fr_CA: "Identifiant de l'œuvre",
          es_MX: 'Identificación de la obra de arte',
        },
        type: 'number',
      },
      quantity: { label: { en_US: 'Quantity', es_MX: '', fr_CA: '' }, type: 'number' },
      reason: { label: { en_US: 'Reason', es_MX: '', fr_CA: '' }, type: 'number' },
      comment: { label: { en_US: 'Comment', es_MX: '', fr_CA: '' }, type: 'number' },
      date: { label: { en_US: 'Date', es_MX: '', fr_CA: '' }, type: 'date' },
    }
    return {
      meta: {
        columns: columns,
      },
      data: newData as unknown as DataRow[],
    }
  })
  const resetStoreState = () => {
    // orders.value = []
  }
  return {
    setOrders,
    addOrder,
    getAllOrders,
    getOrdersAsTable,
    resetStoreState,
  }
})
